 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		5: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"7c49281b672a08e645d1d23c16f2652011a114bf","1":"837014dec7b26194050db25a54eb44242bbb70d8","2":"27aa7b8fd24bd0c25bd212e2613c1d73b138c9cf","3":"e22ec71d452880fca558022cae0fc3c671c9f8fb","4":"ad7f724d","7":"component---src-pages-404-js","8":"component---src-pages-demokratiska-samtal-index-jsx","9":"component---src-pages-demokratiska-samtal-skapa-demokratiska-samtal-handledning-index-jsx","10":"component---src-pages-demokratiska-samtal-skapa-demokratiska-samtal-index-jsx","11":"component---src-pages-demokratiska-samtal-skapa-demokratiska-samtal-kollage-index-jsx","12":"component---src-pages-demokratiska-samtal-skapa-demokratiska-samtal-kollage-list-index-jsx","13":"component---src-pages-demokratiska-samtal-vad-ar-rattvisa-handledning-index-jsx","14":"component---src-pages-demokratiska-samtal-vad-ar-rattvisa-index-jsx","15":"component---src-pages-demokratiska-samtal-vad-ar-rattvisa-pizza-index-jsx","16":"component---src-pages-historiska-perspektiv-index-jsx","17":"component---src-pages-historiska-perspektiv-tidslinjen-oversikt-handledning-index-jsx","18":"component---src-pages-historiska-perspektiv-tidslinjen-oversikt-index-jsx","19":"component---src-pages-historiska-perspektiv-tidslinjen-oversikt-tidslinjen-index-jsx","20":"component---src-pages-historiska-perspektiv-utan-demokratiska-rattigheter-ester-henning-index-jsx","21":"component---src-pages-historiska-perspektiv-utan-demokratiska-rattigheter-handledning-index-jsx","22":"component---src-pages-historiska-perspektiv-utan-demokratiska-rattigheter-index-jsx","23":"component---src-pages-historiska-perspektiv-utan-demokratiska-rattigheter-johan-dimitri-taikon-index-jsx","24":"component---src-pages-historiska-perspektiv-utan-demokratiska-rattigheter-johan-dimitri-taikon-stockholmstidningen-29-augusti-1943-index-jsx","25":"component---src-pages-historiska-perspektiv-utan-demokratiska-rattigheter-maj-britt-johansson-index-jsx","26":"component---src-pages-historiska-perspektiv-utan-demokratiska-rattigheter-maj-britt-johansson-maj-britts-brev-index-jsx","27":"component---src-pages-index-jsx","28":"component---src-pages-om-demokrati-demokratiska-principer-handledning-index-jsx","29":"component---src-pages-om-demokrati-demokratiska-principer-index-jsx","30":"component---src-pages-om-demokrati-index-jsx","31":"component---src-pages-om-demokrati-roster-om-demokrati-handledning-index-jsx","32":"component---src-pages-om-demokrati-roster-om-demokrati-index-jsx","33":"component---src-pages-om-klassrumsmaterialet-index-jsx"}[chunkId]||chunkId) + "-" + {"0":"de555edf0fa1b0de9a5f","1":"b419a6de488c0d1f854b","2":"1086a50c9293771f2be2","3":"7f42a0b1522d18d8319e","4":"c6dceadd4f51aaea049c","7":"82be831f387b22bdd758","8":"ef11aeb02d624a5d864f","9":"46e69c53d1b3ec6602d3","10":"83058ee3d5092f4341df","11":"e01581a431dd9f85c2d2","12":"032004b0e0db247befad","13":"da94003b976ded683bdb","14":"aa25fdd83438c3f600d0","15":"da1dff0c040e15460beb","16":"1f892382aef4b00ddd84","17":"75611ef4407c86f985fa","18":"75175efb06b2c3608739","19":"6aa144825df8b9c34549","20":"4d6f3c4719305010b12c","21":"d38b9fbcbd99ddadb8fc","22":"b640ae70182fc20e50e4","23":"a9346d9316348e7e258a","24":"ec5fa12c82366b6673e4","25":"58679c0aa4e513db1fe8","26":"bc42e96b40677ec52b22","27":"9466017ca1027f0d05e0","28":"f1585c0962eac298cf71","29":"d5ebe528d9e07f7981a7","30":"581ee3d5a3096bd44d4f","31":"fe7403c1bb7e4c668202","32":"86c67432566002c6bb6c","33":"551ac8e25bae03b0d53b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
